import { styled } from '@mui/material';

import { CloseIcon2 } from '../../../assets/icons';

export const CloseButton = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}) => {
  return (
    <Icon onClick={onClick} aria-label="close" className={className}>
      <CloseIcon2 style={{ color: 'currentcolor' }} />
    </Icon>
  );
};

const Icon = styled('button')(({ theme }) => ({
  color: 'var(--color-dark-coal)',
  cursor: 'pointer',
  backgroundColor: 'transparent',
  border: 'none',
  padding: 0,
  transition: 'color var(--transition-duration)',

  '&:hover': {
    color: 'var(--color-light-red)',
  },

  svg: {
    height: '28px',
    width: '28px',
  },

  [theme.breakpoints.up('sm')]: {
    svg: {
      height: '32px',
      width: '32px',
    },
  },

  [theme.breakpoints.up('md')]: {
    svg: {
      height: '36px',
      width: '36px',
    },
  },
}));
